export const isUserLogin = ({ user }) => user.isLogin;
export const isUserEmail = ({ user }) => user.userData.email;
export const currentBalance = ({ user }) => user.userData.balance;
